import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import PageHeader from "../../components/common/PageHeader";
import { useXhr } from "hooks/useXhr";
import { useWhyPhotosContext } from "hooks/useWhyPhotosContext";
import { Button, Spinner } from "react-bootstrap";

function WhyPhotos() {
    //States
    const [status, setStatus] = useState(false);
    const [photosUpdate, setPhotosUpdate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState({
        field: null,
        note: null
    });

    //Hooks
    const { customXhr } = useXhr();
    const { whyPhotos, dispatch } = useWhyPhotosContext();

    const requiredFields = ['alt'];

    //Functions
    const handleOnChange = (e) => {
        const { id, value } = e.target;

        setPhotosUpdate(prevState => ({
            ...prevState,
            [id]: value
        }));
    };

    const generateUniqueFileName = (file) => {
        const timestamp = Date.now();
        const randomNumber = Math.floor(Math.random() * 10000);
        const extension = file.name.split('.').pop();

        return `${timestamp}_${randomNumber}.${extension}`;
    };

    const handleUpdate = (e) => {
        const file = e.target.files[0];
        const id = e.target.id;

        const newFileName = generateUniqueFileName(file);

        const newFile = new File([file], newFileName, { type: file.type });

        setPhotosUpdate(prevState => ({
            ...prevState,
            [id]: newFile
        }));
    };

    const handlePhotosSubmit = async () => {
        for (const field of requiredFields) {
            if (!photosUpdate[field] || photosUpdate[field] === "") {
                return (
                    setError({
                        field: field,
                        note: `Zorunlu alan`
                    }),
                    setIsLoading(false)
                )
            }
        }
        setIsLoading(true);
        const formData = new FormData();
        formData.append('module', 'why_photos');
        formData.append('action', 'update');
        formData.append('id', photosUpdate.id);
        formData.append('photo', photosUpdate.photo);
        formData.append('alt', photosUpdate.alt);

        const response = await customXhr(formData);

        if (response.status === "success") {
            setPhotosUpdate(null);
            setStatus(!status);
            setError({
                field: null,
                note: null
            });
            setIsLoading(false);
        };
    };

    const getWhyPhotos = async () => {
        const formData = new FormData();
        formData.append('module', 'why_photos');
        formData.append('action', 'list');

        const response = await customXhr(formData);

        if (response) {
            dispatch({ type: 'SET_WHY_PHOTOS', payload: response.data });
        };
    };

    useEffect(() => {
        getWhyPhotos();
    }, [status]);

    if (whyPhotos) {
        return (
            <div className="container-xxl">
                <PageHeader headerTitle="Neden Reis Fotoğraf Bölümü" />
                <div className="row align-items-center">
                    <div className="col-lg-12 col-md-12 flex-column">
                        <div className="row g-3 gy-5 py-3 row-deck">

                            <div className="col-12">
                                <div className="card customSliders" style={{ marginTop: "0px" }}>
                                    <div className="card-body" style={{ marginTop: "0px" }}>
                                        <div className="row d-flex justify-content-center" style={{ height: "70vh" }}>
                                            <div className="col-lg-4 col-sm-6">
                                                <div className="service-sub-image" style={{ position: "relative" }}>
                                                    <img
                                                        src={
                                                            process.env.PUBLIC_URL + `/uploads/why_photos/${whyPhotos[0].photoName}`
                                                        }
                                                        alt=""
                                                        style={{ objectFit: "cover", height: "auto" }}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary sustainabilityPhotos"
                                                        onClick={() => setPhotosUpdate(whyPhotos[0])}
                                                    >
                                                        <i className="icofont-edit text-success"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-sm-6">
                                                <div className="service-sub-image" style={{ position: "relative" }}>
                                                    <img
                                                        src={
                                                            process.env.PUBLIC_URL + `/uploads/why_photos/${whyPhotos[1].photoName}`
                                                        }
                                                        alt=""
                                                        style={{ objectFit: "cover", height: "auto" }}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary sustainabilityPhotos"
                                                        onClick={() => setPhotosUpdate(whyPhotos[1])}
                                                    >
                                                        <i className="icofont-edit text-success"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-sm-6">
                                                <div className="service-sub-image" style={{ position: "relative" }}>
                                                    <img
                                                        src={process.env.PUBLIC_URL + `/uploads/why_photos/${whyPhotos[2].photoName}`}
                                                        alt=""
                                                        style={{ objectFit: "cover", height: "auto" }}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary sustainabilityPhotos"
                                                        onClick={() => setPhotosUpdate(whyPhotos[2])}
                                                    >
                                                        <i className="icofont-edit text-success"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <Modal
                    show={photosUpdate}
                    onHide={() => {
                        setPhotosUpdate(null);
                        setError({
                            field: null,
                            note: null
                        });
                        setIsLoading(false);
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title className="fw-bold">Fotoğraf Düzenle</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mb-3">
                            <label htmlFor="alt" className="form-label">
                                {"Seo Kelimeler "}
                                <span className="text-danger">
                                    (Lütfen 5 Kelimeden Fazla Yazmayınız!)
                                </span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="alt"
                                value={photosUpdate && photosUpdate.alt}
                                onChange={handleOnChange}
                                style={{ borderColor: `${error.field === "alt" ? "red" : "var(--border-color)"}` }}
                            />
                            {error.field === "alt" &&
                                <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                            }
                        </div>
                        <div className="mb-3">
                            <label htmlFor="photo" className="form-label">Fotoğraf Yükle</label>
                            <input
                                className="form-control"
                                type="file"
                                id="photo"
                                onChange={handleUpdate}
                            />
                            <div className="form-label" style={{ color: "red" }}>
                                {"Bu alanın geçerli görsel öğe boyutu: 1020x1300"}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="primary"
                            className="me-1"
                            onClick={() => handlePhotosSubmit()}
                            disabled={isLoading}
                        >
                            {
                                isLoading ?
                                    <>
                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                        Yükleniyor...
                                    </> :
                                    <>
                                        Kaydet
                                    </>
                            }
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default WhyPhotos;